/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { S as SelectModal, d as defineCustomElement$1 } from './select-modal.js';
const IonSelectModal = SelectModal;
const defineCustomElement = defineCustomElement$1;
export { IonSelectModal, defineCustomElement };